import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoAccountHolderChangeLogListRequest,
  PerplayLogApi
} from '../../models/src';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import { HOLDER_LOG_LIST_REQUEST } from '../../constants/log/holderLogConstants';
import LogControllerDtoAccountHolderChangeLogListResponse
  from '../../models/src/model/LogControllerDtoAccountHolderChangeLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* holderLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoAccountHolderChangeLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.searchString = payload.searchString;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;

    console.log("요청 데이터: ", requestData);

    const result = yield api.apiPerplayLogAccountHolderChangeLogListPost({ logControllerDtoAccountHolderChangeLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoAccountHolderChangeLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    console.log(e);
    payload.error(e);
  }
}

function* holderLogRootSaga() {
  yield all([takeEvery(HOLDER_LOG_LIST_REQUEST, holderLogListRequestSaga)])
}

const holderLogSaga = [
  fork(holderLogRootSaga)
];

export default holderLogSaga;
